import { useEffect, useRef } from "react";
import { API_BASE_URL } from "../api/http";

const WS_BASE_URL = API_BASE_URL.replace(/^http/i, "ws");

// برخلاف useChatOnlineSocket (که به روم یک chat_id مشخص وصل می‌شه)، این هوک
// از لحظه‌ی mount به یک روم سراسری وصل می‌شه که مستقل از chat_id هست. برای
// همین حتی چت‌هایی که تازه ساخته شدن و هنوز هیچ‌کس به روم مخصوص خودشون وصل
// نشده هم از طریق این کانال دیده می‌شن. برای صفحات لیست/آرشیو استفاده کن.
export default function useChatOnlineListSocket({ onUpdate } = {}) {
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  useEffect(() => {
    let socket = null;
    let closedByCleanup = false;
    let reconnectTimer = null;

    const connect = () => {
      if (closedByCleanup) return;

      socket = new WebSocket(`${WS_BASE_URL}/ws/chat-online-list/`);

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "chat_updated") {
            onUpdateRef.current?.(data.chat_id);
          }
        } catch (error) {
          console.error("Chat list WebSocket parse error:", error);
        }
      };

      socket.onerror = (error) => {
        console.error("Chat list WebSocket error:", error);
        socket.close();
      };

      socket.onclose = () => {
        if (!closedByCleanup) {
          reconnectTimer = setTimeout(connect, 3000);
        }
      };
    };

    connect();

    return () => {
      closedByCleanup = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (socket) socket.close();
    };
  }, []);
}
